import { DS_USER_STATUS, DSUserStatus } from "@/src/design_system/data_display/user/types/status";

export const DS_USER_CLASSES = {
  Root: "ds-user",
  Action: "ds-user--action",
  Details: "ds-user__details",
  Name: "ds-user__name",
  Status: "ds-user__status",
  StatusNone: "ds-user__status--none",
  StatusOnline: "ds-user__status--online",
  StatusOffline: "ds-user__status--offline",
  StatusAway: "ds-user__status--away",
  StatusDoNotDisturb: "ds-user__status--dnd",
} as const;

export const DS_USER_STATUS_TO_CLASS_MAP: Record<DSUserStatus, string> = {
  [DS_USER_STATUS.None]: DS_USER_CLASSES.StatusNone,
  [DS_USER_STATUS.Online]: DS_USER_CLASSES.StatusOnline,
  [DS_USER_STATUS.Offline]: DS_USER_CLASSES.StatusOffline,
  [DS_USER_STATUS.Away]: DS_USER_CLASSES.StatusAway,
  [DS_USER_STATUS.DoNotDisturb]: DS_USER_CLASSES.StatusDoNotDisturb,
};

export const DS_USER_AVATAR_CLASSES = {
  Root: "ds-user-avatar",
  Image: "ds-user-avatar__image",
  Text: "ds-user-avatar__text",
  Icon: "ds-user-avatar__icon",
  TypeImage: "ds-user-avatar--image",
  TypeText: "ds-user-avatar--text",
  TypeIcon: "ds-user-avatar--icon",
  TypeGroup: "ds-user-avatar--group",
  StatusNone: "ds-user-avatar--none",
  StatusOnline: "ds-user-avatar--online",
  StatusOffline: "ds-user-avatar--offline",
  StatusAway: "ds-user-avatar--away",
  StatusDoNotDisturb: "ds-user-avatar--dnd",
} as const;

export const DS_USER_AVATAR_STATUS_TO_CLASS_MAP: Record<DSUserStatus, string> = {
  [DS_USER_STATUS.None]: DS_USER_AVATAR_CLASSES.StatusNone,
  [DS_USER_STATUS.Online]: DS_USER_AVATAR_CLASSES.StatusOnline,
  [DS_USER_STATUS.Offline]: DS_USER_AVATAR_CLASSES.StatusOffline,
  [DS_USER_STATUS.Away]: DS_USER_AVATAR_CLASSES.StatusAway,
  [DS_USER_STATUS.DoNotDisturb]: DS_USER_AVATAR_CLASSES.StatusDoNotDisturb,
};
